import { makeStyles } from "@material-ui/styles";
import bookingBg2 from "../../images/booking-bg2.png";

const styles = makeStyles((theme) => ({
    bookingwrapper: {
		height: 570,
		width: 275,
		top: 56,
		zIndex: "11",
		backgroundImage: `url(${bookingBg2})`,
		display: "flex",
		flexDirection: "column",
		[theme.breakpoints.down("sm")]: {
			display: "none"
		}
	},
	outer: {
		position: "absolute",
		zIndex: "1",
		[theme.breakpoints.down("sm")]: {
			display: "none"
		}
	},
	bookingheader: {
		color: "#fff",
		textAlign: "center",
		background: "#78858c",
		padding: 15
	},
	formWrap: {
		padding: 20
	},
	formContent: {
		padding: "20px 20px"
	},
	newBrave: {
		fontFamily: "BreveSC!important"
	},
    logoouter: {
		width: 170,
		width: 170,
		margin: "auto",
		marginTop: -50,
		transition:".3s",
		[theme.breakpoints.down("lg")]:{
			width: 140,
			marginLeft: 20,
			marginTop: -30,
		},
		[theme.breakpoints.down("md")]: {
			width: 130,
			left: "calc(50% - 65px)",
			bottom: -60,
		},
		[theme.breakpoints.down("sm")]:{
			width: "auto",
			marginLeft:0,
			marginTop:-20,
		}
	},
    send: {
		background: "#fff",
		color: "#000",
		fontWeight: "700",
		border: "none",
		outline: "none",
		width: "100%",
		borderRadius: 0,
		marginTop: 0,
		height: "50px"
	},
	formControl: {
		width: "100%",
		marginBottom: 20
	},
	paper: {
		position: 'absolute',
		width: 400,
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
}));
export default styles;
